import React, { Component } from "react"
import { connect } from 'react-redux'
import moment from 'moment'
import $ from 'jquery'
import { Div, Input, DatePicker, Select, TextArea, DropDownList, InputDecimal } from "../core";
import utilityHelper from '../../helpers/helperUtil'
import {
    updateUserModalAction,
    createUserAction,
    updateUserAction,
    clearErrorMsgAction
} from '../../redux/actions/UserAction'
import { Constants, MessageText, Storage } from '../../configs'
import { msg } from '../../components/Notifications/MsgBox';
import { async } from "q";
import { getAllOrgUnitsAction } from "../../redux/actions/MasterAction";
import {
    setKeyValueAction as setKeyValueEmployeeModalAction,
    clearModalAction as clearEmployeeModalAction,
} from '../../redux/actions/ModalEmployeeAction'
import {
    clearSearchDirectoryInfoAction,
} from '../../redux/actions/MasterAction'
import unitCodeReviewer from '../../configs/datas/unitcode_reviewer'

class UserModal extends Component {

    constructor(props) {
        super(props)

        this.state = {
            ...props,
            docType: '',
            userModal: {},
            isView: false,
            org_unit: []
        }

        this.handleChange = this.handleChange.bind(this)
        this.saveUser = this.saveUser.bind(this)

        window.onUserSearchEmployeeSelected = this.handleUserSearchEmployeeSelected.bind(this)

    }

    componentDidMount() {
        const user = Storage.getUser()
        //this.props.getAllOrgUnits()
    }

    async componentWillReceiveProps(nextProps) {
        if (nextProps.userModal) {
            if ((this.state.userModal.index !== nextProps.userModal.index ||
                this.state.userModal.index === "" ||
                (this.state.userModal.index !== "" && this.state.userModal.item !== nextProps.userModal.item)
                ) && nextProps.errorMsg === "") {
                let userModal = nextProps.userModal
                if (userModal.index !== "") {
                    userModal.item = this.props.userData[userModal.index]
                } else {
                    const user = Storage.getUser()
                    let localuser = ""
                    if (user) {
                        localuser = user.userName
                    }

                    userModal.item = {
                        userName: "",
                        firstName: "",
                        lastName: "",
                        prefix: "",
                        email: "",
                        unitCode: "",
                        sapUser: "",
                        isAdmin: false,
                        isActive: true,
                        userGroup: "Creator",
                        createBy: localuser,
                        unitName: "",
                        unitSubName: ""
                    }
                }
                let docType = ''
                if(typeof this.state.org_unit !== "undefined" && this.state.org_unit !== null && this.state.org_unit.length === 0) {
                    var org_unit = this.setOrg_Unit()
                    await this.setState({
                        userModal: {
                            index: userModal.index,
                            item: userModal.item
                        },
                        org_unit: org_unit
                    })    
                } else {
                    await this.setState({
                        userModal: {
                            index: userModal.index,
                            item: userModal.item
                        }
                    })    
                }

            }
        }
        $(function () {
            window.onComponentDidMount()
        })
    }
    setOrg_Unit() {
        const { org_unit } = this.props
        let result = null
        result = utilityHelper.toSelectList_CombineFields(org_unit, "unitcode", "unitabbr", "unitcode")

        return result
    }

    async handleChange(event) {
        // console.log("handleChange", event.target
        const target = event.target;
        const valid = event.target.validity.valid
        let value = target.type === 'checkbox' ? (target.checked ? 1 : 0) : target.value;
        const name = target.name;
        const userType = target.userType

        //check date
        if ((value.toString()).indexOf("/") > 0) {
            let dateData = (value.toString()).split("/")
            let dateDataLength = dateData.length
            if (dateDataLength === 3) {
                if (moment(value, 'DD/MM/YYYY').isValid()) {
                    value = moment(value, 'DD/MM/YYYY').format('YYYY-MM-DD')
                }
            }
        }

        if (valid) {

            if (name === "Active") {
                if (target.checked) {
                    this.setState({
                        userModal: {
                            ...this.state.userModal,
                            item: {
                                ...this.state.userModal.item,
                                ["isActive"]: true
                            }
                        }
                    })
                }
            }
            else if (name === "Inactive") {
                if (target.checked) {
                    this.setState({
                        userModal: {
                            ...this.state.userModal,
                            item: {
                                ...this.state.userModal.item,
                                ["isActive"]: false
                            }
                        }
                    })
                }
            }
            else if (name === "Admin") {
                if (target.checked) {
                    this.setState({
                        userModal: {
                            ...this.state.userModal,
                            item: {
                                ...this.state.userModal.item,
                                ["isAdmin"]: true
                            }
                        }
                    })
                }
            }
            else if (name === "User") {
                if (target.checked) {
                    this.setState({
                        userModal: {
                            ...this.state.userModal,
                            item: {
                                ...this.state.userModal.item,
                                ["isAdmin"]: false
                            }
                        }
                    })
                }
            }
            else if (name === "userGroup") {
                if (target.checked) {
                    let userGroup = this.state.userModal.item.userGroup == 'Creator' ? 'Reviewer' : 'Creator';
                    this.setState({
                        userModal: {
                            ...this.state.userModal,
                            item: {
                                ...this.state.userModal.item,
                                ["userName"]: null,
                                ["firstName"]: null,
                                ["lastName"]: null,
                                ["prefix"]: null,
                                ["email"]: null,
                                ["unitCode"]: null,
                                ["sapUser"]: null,
                                ["isAdmin"]: false,
                                ["userGroup"]: userGroup,
                                ["isActive"]: true
                            }
                        }
                    })
                }
            }
            else if (name === "unitCode") {
                var isUnitCodeReviewer = unitCodeReviewer.some(s => s === value)
                var unitCodeSelected = this.state.org_unit.find(f => f.value === value)
                let unitSubName = ""
                if (unitCodeSelected) {
                    let unitSubnames = unitCodeSelected.label.split(':')
                    unitSubName = unitSubnames[unitSubnames.length - 1].trim()        
                }
        
                let userGroup = "Creator"
                if (isUnitCodeReviewer) {
                    userGroup = "Reviewer"
                }
                this.setState({
                    userModal: {
                        ...this.state.userModal,
                        item: {
                            ...this.state.userModal.item,
                            [name]: value,
                            ["userGroup"]: userGroup,
                            ["unitSubName"]: unitSubName,
                        }
                    }
                })
            } else {
                this.setState({
                    userModal: {
                        ...this.state.userModal,
                        item: {
                            ...this.state.userModal.item,
                            [name]: value
                        }
                    }
                })
            }
        } else {
            return
        }
    }

    validateUserItem() {
        const { userModal } = this.state
        let role = 'C'
        let msgvalidate = ""

        if (userModal.item.unitCode) {
            var unitReviewer = unitCodeReviewer;
            if (unitReviewer.indexOf(userModal.item.unitCode) > -1)
                role = 'R'
        }

        if (!userModal.item.userName) {
            msgvalidate += "กรุณาระบุ Username <br/>"
        }
        if (userModal.item.userName && !this.validateUsername(userModal.item.userName)) {
            msgvalidate += "รูปแบบ Username ไม่ถูกต้อง  <br/>"
        }
        if (!userModal.item.email) {
            msgvalidate += "กรุณาระบุ E-mail <br/>"
        }
        if (userModal.item.email && !this.validateEmail(userModal.item.email)) {
            msgvalidate += "รูปแบบ E-mail ไม่ถูกต้อง  <br/>"
        }
        if (!userModal.item.prefix) {
            msgvalidate += "กรุณาระบุ Prefix <br/>"
        }
        if (!userModal.item.userGroup) {
            msgvalidate += "กรุณาระบุ User Type <br/>"
        }
        if (!userModal.item.firstName) {
            msgvalidate += "กรุณาระบุ First Name <br/>"
        }
        if (!userModal.item.lastName) {
            msgvalidate += "กรุณาระบุ Last Name <br/>"
        }
        if (!userModal.item.unitCode) {
            msgvalidate += "กรุณาระบุ Organization Unit <br/>"
        }
        if (userModal.item.isAdmin === null) {
            msgvalidate += "กรุณาระบุ Role <br/>"
        }
        if (userModal.item.isActive === null && userModal.item.userGroup !== 'Reviewer') {
            msgvalidate += "กรุณาระบุ Status <br/>"
        }
        if (!userModal.item.sapUser && role === 'R' && userModal.item.userGroup !== 'Reviewer') {
            msgvalidate += "กรณี Organization Unit เป็น หน่วยงาน Reviewer กรุณาระบุ Sap User <br/>"
        }
        if (msgvalidate) {
            return { error_message: msgvalidate }
        }
        return null
    }

    async saveUser() {
        // console.log("saveUser")
        let errors = []
        let _validateUser = this.validateUserItem()
        if (_validateUser !== null) {
            errors.push(_validateUser)
        }
        let error_messages = []
        if (errors.length > 0) {
            errors.forEach((error, index) => {
                error_messages.push(error.error_message)
            })
            msg.error(error_messages.join('<br/>'))
        }
        else {
            if (this.state.userModal.index === "") {
                msg.showConfirm("Confirm",
                    MessageText.PAGE.USER.POPUP_MSG_CONFIRM_CREATE,
                    async () => {
                        msg.hideConfirm()
                        await this.props.createUser(this.state.userModal.item)
                        if (this.props.errorMsg !== "") {
                            msg.error(this.props.usererrorMsg)
                            this.props.clearErrorMsg()
                        } else {
                            msg.success(MessageText.PAGE.USER.POPUP_MSG_SUCCESS_CREATE)
                            $(function () {
                                window.onSavePopupUser()
                                window.$('#userModal').modal('hide')
                            })
                        }
                    },
                    () => {
                        msg.hideConfirm()
                        console.log("On Cancel")
                    },
                    () => {
                        console.log("On Closed")
                    }
                )

            } else {
                msg.showConfirm(
                    "Confirm",
                    MessageText.PAGE.USER.POPUP_MSG_CONFIRM_UPDATE,
                    async () => {
                        msg.hideConfirm()
                        await this.props.updateUser(this.state.userModal.item)
                        if (this.props.errorMsg !== "") {
                            msg.error(this.props.errorMsg)
                            // this.props.clearErrorMsg()
                        } else {
                            msg.success(MessageText.PAGE.USER.POPUP_MSG_SUCCESS_UPDATE)
                            $(function () {
                                window.onSavePopupUser()
                                window.$('#userModal').modal('hide')
                            })
                        }
                    },
                    () => {
                        msg.hideConfirm()
                        console.log("On Cancel")
                    },
                    () => {
                        console.log("On Closed")
                    }
                )
            }
        }
    }

    handleUserSearchEmployeeSelected(key, empCode, empName, empData) {
        if (!empCode || !empName) return
        var name = empName.split(" ");
        if (key == "M_USER") {
            this.setState({
                userModal: {
                    ...this.state.userModal,
                    item: {
                        ...this.state.userModal.item,
                        userName: empCode,
                        firstName: name[0] + "",
                        lastName: name[1] + "",
                        prefix: empData.iname + "",
                        email: empData.eMailAddress + "",
                        unitCode: empData.departmentCode + "",
                        sapUser: "0010" + empCode,
                        isAdmin: false
                    }
                }
            })
        }
    }

    searchEmployeeModal(empCode, empName) {
        if (this.state.userModal.item.userGroup === "Reviewer") {
            this.props.clearSearchDirectoryInfo();
            this.props.clearEmployeeModal();
            this.props.setKeyValueEmployeeModal('M_USER', empCode, empName)

            window.$('#searchEmployeeModal').modal('show');
        }


    }

    validateEmail(email) {
        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    }

    validateUsername(username) {
      
        if (username.length > 1 && username.toLowerCase() != "admin" ) {
            console.log(username.substring(0, 2));
            let checkuser = username.substring(0, 2)
            var re = /^[0-9]*$/;
            if (this.validateEmail(username)) {
                return true
            }
            else if (re.test(String(checkuser))) {
                return true
            }
            else if (checkuser.toLowerCase() == "ch") {
                return true
            }
            else{
                return false
            }
        }
        else{
            return true
        }
    }

    render() {
        const { userModal, org_unit } = this.state
        const roleAdmin = Storage.getRoleAdmin()
        return (
            <div className="modal fade sp-modal rrs-modal" id="userModal" tabIndex={-1} role="dialog" aria-labelledby="userModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-xl modal-dialog-centered" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="userModalLabel">ข้อมูลผู้ใช้งาน</h5>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">×</span>
                            </button>
                        </div>
                        {this.state.userModal.item && (<div className="modal-body">
                            <div className="rrs-detail-data sp-table-container">
                                <div id="div_UserInfo" className="rrs-detail">

                                    {/* <div className="collapse show" id="collapseItemInfo"> */}
                                    <div className="rrs-detail pt-2 pb-3 px-3 item-information">
                                        <div className="row">
                                            <div className="col-md-2"></div>
                                            <div className="col-md-4">
                                                <div className="rrs-form">
                                                    <label htmlFor="short_text" className="rrs-label"><span className="required">*</span> ประเภทของผู้ใช้</label>
                                                    <div className="rrs-detail-data">
                                                        <div className="row">
                                                            <div className="col-md-4">
                                                                <label className="radiocontainer">Creator
                                                                    <input
                                                                        type="radio"
                                                                        name="userGroup"
                                                                        value={"Creator"}
                                                                        checked={(userModal.item.userGroup === "Creator")}
                                                                        onChange={this.handleChange}
                                                                        disabled={true}
                                                                    //disabled={userModal.index !== ""} 
                                                                    />
                                                                    <span className="checkmark" />
                                                                </label>
                                                            </div>
                                                            <div className="col-md-4">
                                                                <label className="radiocontainer">Reviewer
                                                                    <input
                                                                        type="radio"
                                                                        name="userGroup"
                                                                        value={"Reviewer"}
                                                                        checked={(userModal.item.userGroup === "Reviewer")}
                                                                        disabled={true}
                                                                        //disabled={userModal.index !== ""}
                                                                        onChange={this.handleChange} />
                                                                    <span className="checkmark" />
                                                                </label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-4">
                                                <div className="rrs-form">
                                                    <label htmlFor="userName" className="rrs-label"><span className="required">*</span> Username</label>
                                                    <div className="rrs-detail-data">
                                                        <input
                                                            key={`itemModal_${userModal.item.userName}_${userModal.item.userName}`}
                                                            type="text"
                                                            disabled={roleAdmin ? false : true}
                                                            name="userName"
                                                            defaultValue={userModal.item.userName}
                                                            className="form-control userName"
                                                            id="userName"
                                                            onBlur={this.handleChange}
                                                            //disabled={userModal.index !== ""}
                                                            readOnly={userModal.item.userGroup === "Reviewer"}
                                                            className={"form-control form-control-search" + ((userModal.item.userGroup !== "Creator") ? " search-user-icon" : "")}
                                                            onClick={() => this.searchEmployeeModal("firstName", "lastName")}

                                                        />
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                        <div className="row">
                                            <div className="col-md-2"></div>
                                            <div className="col-md-4">
                                                <div className="rrs-form">
                                                    <label htmlFor="email" className="rrs-label"><span className="required">*</span> Email</label>
                                                    <div className="rrs-detail-data">
                                                        <Input
                                                            key={`itemModal_${userModal.item.userName}_${userModal.item.email}`}
                                                            type="text"
                                                            disabled={roleAdmin ? false : true}
                                                            name="email"
                                                            defaultValue={userModal.item.email}
                                                            className="email"
                                                            id="email"
                                                            onBlur={this.handleChange}
                                                            doctype={this.state.docType}
                                                            tagid="user.email"
                                                        //autocomplete="off"
                                                        //disabled={userModal.item.userGroup === "Reviewer"}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-4">
                                                <div className="rrs-form">
                                                    <label htmlFor="prefix" className="rrs-label"><span className="required">*</span> คำนำหน้าชื่อ</label>
                                                    <div className="rrs-detail-data">
                                                        <Select
                                                            key={`itemModal_${userModal.item.userName}_${userModal.item.prefix}`}
                                                            type="text"
                                                            disabled={roleAdmin ? false : true}
                                                            name="prefix"
                                                            defaultValue={userModal.item.prefix}
                                                            className="prefix"
                                                            id="prefix"
                                                            onBlur={this.handleChange}
                                                            doctype={this.state.docType}
                                                            tagid="user.prefix"
                                                        //autocomplete="off"
                                                        //disabled={userModal.item.userGroup === "Reviewer"}
                                                        >
                                                            <option
                                                                key='0'
                                                                value={null}>
                                                                กรุณาเลือก...</option>
                                                            <option
                                                                key='1'
                                                                value={'นาย'}>
                                                                นาย</option>
                                                            <option
                                                                key='2'
                                                                value={'นาง'}>
                                                                นาง</option>
                                                            <option
                                                                key='3'
                                                                value={'น.ส.'}>
                                                                น.ส.</option>
                                                        </Select>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                        <div className="row">
                                            <div className="col-md-2"></div>
                                            <div className="col-md-4">
                                                <div className="rrs-form">
                                                    <label htmlFor="firstName" className="rrs-label"><span className="required">*</span> ชื่อ</label>
                                                    <div className="rrs-detail-data">
                                                        <Input
                                                            key={`itemModal_${userModal.item.userName}_${userModal.item.firstName}`}
                                                            type="text"
                                                            disabled={roleAdmin ? false : true}
                                                            name="firstName"
                                                            defaultValue={userModal.item.firstName}
                                                            className="firstName"
                                                            id="firstName"
                                                            onBlur={this.handleChange}
                                                            doctype={this.state.docType}
                                                            tagid="user.firstName"
                                                        //autocomplete="off"
                                                        //disabled={userModal.item.userGroup === "Reviewer"}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-4">
                                                <div className="rrs-form">
                                                    <label htmlFor="lastName" className="rrs-label"><span className="required">*</span> นามสกุล</label>
                                                    <div className="rrs-detail-data">
                                                        <Input
                                                            key={`itemModal_${userModal.item.userName}_${userModal.item.lastName}`}
                                                            type="text"
                                                            disabled={roleAdmin ? false : true}
                                                            name="lastName"
                                                            defaultValue={userModal.item.lastName}
                                                            className="lastName"
                                                            id="lastName"
                                                            onBlur={this.handleChange}
                                                            doctype={this.state.docType}
                                                            tagid="user.lastName"
                                                        //autocomplete="off"
                                                        //disabled={userModal.item.userGroup === "Reviewer"}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-2"></div>
                                            <div className="col-md-4">
                                                <div className="rrs-form">
                                                    <label htmlFor="unitCode" className="rrs-label"><span className="required">*</span> หน่วยงานผู้สร้าง</label>
                                                    <div className="rrs-detail-data">
                                                        <DropDownList
                                                            key={`itemModal_${userModal.item.userName}_${userModal.item.unitCode}`}
                                                            name="unitCode"
                                                            options={org_unit}
                                                            onSelectChanged={this.handleChange}
                                                            selected={userModal.item.unitCode}
                                                            doctype={this.state.docType}
                                                            className="unitCode"
                                                            tagid="user.unitCode"
                                                            disabled={roleAdmin ? false : true}
                                                        //disabled={userModal.item.userGroup === "Reviewer"}
                                                        >
                                                        </DropDownList>

                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-4">
                                                <div className="rrs-form">
                                                    <label htmlFor="sapUser" className="rrs-label">
                                                        {/* <span className="required">*</span> */}
                                                   Username ที่เข้าใช้งานในระบบ SAP</label>
                                                    <div className="rrs-detail-data">
                                                        <Input
                                                            key={`itemModal_${userModal.item.userName}_${userModal.item.sapUser}`}
                                                            type="text"
                                                            disabled={roleAdmin ? false : true}
                                                            // pattern="[0-9]*"
                                                            // inputMode="decimal"
                                                            maxlength="15"
                                                            floatingPoint={0}
                                                            name="sapUser"
                                                            defaultValue={this.state.userModal.item.sapUser}
                                                            className="sapUser"
                                                            id="sapUser"
                                                            onBlur={this.handleChange}
                                                            doctype={this.state.docType}
                                                            tagid="user.sapUser"
                                                        //autocomplete="off"
                                                        //disabled={userModal.item.userGroup === "Reviewer"}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-2"></div>
                                            {/* <div className="col-md-4">
                                                <div className="rrs-form">
                                                    <label htmlFor="short_text" className="rrs-label"><span className="required">*</span> Role</label>
                                                    <div className="rrs-detail-data">
                                                        <div className="row">
                                                            <div className="col-md-4">
                                                                <label className="radiocontainer">Admin
                                                                    <input
                                                                        type="radio"
                                                                        name="Admin"
                                                                        value={true}
                                                                        checked={(this.state.userModal.item.isAdmin === true)}
                                                                        onChange={this.handleChange}
                                                                         />
                                                                    <span className="checkmark" />
                                                                </label>
                                                            </div>
                                                            <div className="col-md-4">
                                                                <label className="radiocontainer">User
                                                                    <input
                                                                        type="radio"
                                                                        name="User"
                                                                        value={false}
                                                                        checked={(this.state.userModal.item.isAdmin === false)}
                                                                        onChange={this.handleChange} />
                                                                    <span className="checkmark" />
                                                                </label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div> */}
                                            <div className="col-md-4" >
                                                <div className="rrs-form">
                                                    <label htmlFor="status" className="rrs-label"><span className="required" style={{ visibility: userModal.item.userGroup === "Reviewer" ? "hidden" : "" }}>*</span> สถานะ</label>
                                                    <div className="rrs-detail-data">
                                                        <div className="row">
                                                            <div className="col-md-4">
                                                                <label className="radiocontainer">ใช้งาน
                                                                    <input
                                                                        type="radio"
                                                                        name="Active"
                                                                        value={true}
                                                                        checked={(this.state.userModal.item.isActive === true)}
                                                                        onChange={this.handleChange}
                                                                        disabled={roleAdmin ? false : true}
                                                                    //disabled={userModal.item.userGroup === "Reviewer"} 
                                                                    />
                                                                    <span className="checkmark" />
                                                                </label>
                                                            </div>
                                                            <div className="col-md-4">
                                                                <label className="radiocontainer">ไม่ใช้งาน
                                                                    <input
                                                                        type="radio"
                                                                        name="Inactive"
                                                                        value={false}
                                                                        checked={(this.state.userModal.item.isActive === false)}
                                                                        onChange={this.handleChange}
                                                                        disabled={roleAdmin ? false : true}
                                                                    //disabled={userModal.item.userGroup === "Reviewer"}  
                                                                    />
                                                                    <span className="checkmark" />
                                                                </label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {/* </div> */}
                                </div>


                                <div className="rrs-detail py-1">
                                    <div className="row sp-table-content-footer">
                                        <div className="col-10 sp-header-button-panel2"></div>
                                        <div className="col-2 sp-header-button-panel2">
                                            <a href="#" className="sp-btn-icon btn-del" data-dismiss="modal">
                                                <i className="icon btn-order-delete" />
                                                <span className="sp-btn-icon-label">Close</span>
                                            </a>

                                            <a href="#user" className="sp-btn-icon" onClick={() => this.saveUser()} style={{ display: roleAdmin ? "" : "none" }}>
                                                <i className="icon btn-order-savedraft" />
                                                <span className="sp-btn-icon-label">Save</span>
                                            </a>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>)}
                    </div>
                </div>
            </div >
        )

    }
}

const mapStateToProps = state => {
    const { UserRedux, MasterRedux } = state
    return {
        userData: UserRedux.userData,
        userModal: UserRedux.userModal,
        errorMsg: UserRedux.errorMsg,
        org_unit: MasterRedux.org_unit,
        usererrorMsg: UserRedux.usererrorMsg,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        createUser: (data) => dispatch(createUserAction(data)),
        updateUser: (data) => dispatch(updateUserAction(data)),
        updateUserModal: (data) => dispatch(updateUserModalAction(data)),
        clearErrorMsg: () => dispatch(clearErrorMsgAction()),
        getAllOrgUnits: () => dispatch(getAllOrgUnitsAction()),
        clearSearchDirectoryInfo: () => dispatch(clearSearchDirectoryInfoAction()),
        clearEmployeeModal: () => dispatch(clearEmployeeModalAction()),
        setKeyValueEmployeeModal: (table, empCode, empName) => dispatch(setKeyValueEmployeeModalAction(table, empCode, empName)),

    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(UserModal)